import buttonStyles from '../../styles/UI/Button.module.css';

export const LinkButton = ({
	classes,
	title,
	href,
}: {
	classes?: string;
	title: string;
	href: string;
}) => {
	const classList = `${buttonStyles.button} ${classes ? classes : ''}`;

	return (
		<a className={classList} href={href}>
			{title}
		</a>
	);
};
